<script setup lang="ts">
import { UiBadge } from "@packages/component-library";
import {
  IconFirstFill,
  IconPayFill,
  IconPercentFill,
  IconTspFill,
} from "@packages/icon-library";
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits([
  "showPaymentModal",
  "showYandexTermModal",
  "showCashbackModal",
]);

const { t } = useI18n();
const placeStore = usePlaceStore();
const place = computed(() => placeStore.place);
</script>

<template>
  <div class="place-badges">
    <UiBadge
      v-if="place?.place.badges.includes('top')"
      :label="t('place.badges.top')"
      size="s"
      type="soft"
      color="pink"
    >
      <IconFirstFill />
    </UiBadge>
    <UiBadge
      v-if="place?.place.cashback_percent"
      :label="
        t('place.badges.cashback', { cashback: place?.place.cashback_percent })
      "
      size="s"
      type="soft"
      color="green"
      clickable
      @click="emit('showCashbackModal')"
    >
      <IconPercentFill />
    </UiBadge>
    <UiBadge
      v-if="place?.place.points_percent"
      :label="t('place.badges.points', { points: place?.place.points_percent })"
      size="s"
      type="soft"
      color="yellow"
      clickable
      @click="emit('showPaymentModal')"
    >
      <IconPayFill />
    </UiBadge>
    <UiBadge
      v-if="place?.place.discount_percent"
      :label="
        t('place.badges.discount', { discount: place?.place.discount_percent })
      "
      size="s"
      type="soft"
      color="purple"
    >
      <IconTspFill />
    </UiBadge>
    <UiBadge
      v-if="place?.place.badges.includes('yandex_food')"
      :label="t('place.badges.yandex')"
      size="s"
      type="soft"
      color="blue"
      clickable
      @click="emit('showYandexTermModal')"
    >
      <img src="@/assets/images/yandex-lavka.svg" alt="" />
    </UiBadge>
  </div>
</template>

<style scoped lang="scss">
.place-badges {
  margin: calc($base-space * 6) 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: calc($base-space * 2);

  @media (max-width: 767px) {
    margin: calc($base-space * 5) 0 0;
  }
}
</style>
